// extracted by mini-css-extract-plugin
export default {"form":"update-password-section_form__54vIZ"};